import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

const RESIZE = 'resize';
export const RESIZE_DEBOUNCE_DELAY = 275;

export const useWindowSize = () => {
  const [height, setHeight] = useState<number>(0);
  const [width, setWidth] = useState<number>(0);

  const syncSizes = useCallback(() => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);
  }, []);

  const debouncedSyncSizes = useDebouncedCallback(() => {
    syncSizes();
  }, RESIZE_DEBOUNCE_DELAY);

  useEffect(() => {
    syncSizes();
    window.addEventListener(RESIZE, debouncedSyncSizes);

    return () => {
      window.removeEventListener(RESIZE, debouncedSyncSizes);
    };
  }, [debouncedSyncSizes, syncSizes]);

  return useMemo(() => ({ width, height, sync: syncSizes }), [width, height, syncSizes]);
};
